import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './util/components/header/header.component';

import { MatSidenavModule } from '@angular/material/sidenav';
import { TrackingConsentBannerComponent } from './util/tracking/tracking-consent-banner/tracking-consent-banner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    MatSidenavModule,
    TrackingConsentBannerComponent,
  ],
})
export class AppComponent {}
